import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

let blocks = document.querySelectorAll('.image-video-block');

if(blocks.length > 0) {
  blocks.forEach(block => {
    const container = block.querySelector('figure');

    gsap.from(container,{
      scrollTrigger: {
        trigger: container,
        start: 'top 80%',
      },
      y: 40,
      autoAlpha: 0.2,
    });
  });
}